import addSourceCodeToInputs from "./AddSourceCodeToInputs";
import addSourceCodeToEarthHourButtons from "./AddSourceCodeToEarthHourButtons";
import addSourceCodeToSupportLinks from "./AddSourceCodeToSupportLinks";
import fetchSourceCodeFromUrl from "./FetchSourceCodeFromUrl";
import fetchSourceCodeFromLocalStorage from "./FetchSourceFromLocalStorage";
import fetchSourceCodeFromCookie from "./FetchSourceCodeFromCookie";
import saveSourceCodeToCookie from "./SaveSourceCodeToCookie";
import saveSourceCodeToSession from "./SaveSourceCodeToSessionStorage";

/**
 * Executes the source code scourer
 *
 * @constructor
 */
const Execute = () => {
  let sourcecode = "";

  try {
    sourcecode = fetchSourceCodeFromUrl() || fetchSourceCodeFromLocalStorage();

    if (sourcecode) {
      addSourceCodeToInputs(sourcecode);

      addSourceCodeToEarthHourButtons(sourcecode);

      addSourceCodeToSupportLinks(sourcecode);

      if (!fetchSourceCodeFromLocalStorage()) {
        saveSourceCodeToSession(sourcecode);
      }
    }
  } catch (e) {
    sourcecode = fetchSourceCodeFromUrl() || fetchSourceCodeFromCookie();

    if (sourcecode) {
      addSourceCodeToInputs(sourcecode);

      addSourceCodeToEarthHourButtons(sourcecode);

      addSourceCodeToSupportLinks(sourcecode);

      if (!fetchSourceCodeFromCookie()) {
        saveSourceCodeToCookie(sourcecode);
      }
    }
  }
};

export default Execute;
